import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    medicalInfoShared: string;
    step: {
        pending: {
            continueButton: string;
            redirectUrl: string;
        };
    };
};

export const medicalMessagesES: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    medicalInfoShared: "La información ingresada aquí se utilizará con fines de verificación. La información se compartirá con Levi's.",
    step: {
        pending: {
            continueButton: "Continuar a Levi's",
            redirectUrl: 'https://www.levi.com/US/es_US/',
        },
    },
};
